var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReject(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gumb-App-(MVP)",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Community-settings-requests_owner-user_MVP-2_desktop",
    transform: "translate(-719.000000, -740.000000)",
    fill: "#A5BFCE",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Delete",
    transform: "translate(719.000000, 733.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.99997854,7.53128688 C13.8163733,7.53128688 17.7187078,11.4336213 17.7187078,16.2500161 C17.7187078,21.0664109 13.8163733,24.9687453 8.99997854,24.9687453 C4.18358378,24.9687453 0.281249329,21.0664109 0.281249329,16.2500161 C0.281249329,11.4336213 4.18358378,7.53128688 8.99997854,7.53128688 Z M8.99997854,23.2812493 C12.8847349,23.2812493 16.0312118,20.1347725 16.0312118,16.2500161 C16.0312118,12.3652597 12.8847349,9.21878286 8.99997854,9.21878286 C5.11522218,9.21878286 1.96874531,12.3652597 1.96874531,16.2500161 C1.96874531,20.1347725 5.11522218,23.2812493 8.99997854,23.2812493 Z M12.5788694,14.0632957 L10.392149,16.2500161 L12.5788694,18.4367365 C12.7441102,18.6019773 12.7441102,18.8691505 12.5788694,19.0343913 L11.7843538,19.8289069 C11.6191129,19.9941478 11.3519398,19.9941478 11.1866989,19.8289069 L8.99997854,17.6421865 L6.81325814,19.8289069 C6.64801729,19.9941478 6.38084416,19.9941478 6.21560331,19.8289069 L5.42108769,19.0343913 C5.25584684,18.8691505 5.25584684,18.6019773 5.42108769,18.4367365 L7.60780809,16.2500161 L5.42108769,14.0632957 C5.25584684,13.8980548 5.25584684,13.6308817 5.42108769,13.4656409 L6.21560331,12.6711252 C6.38084416,12.5058844 6.64801729,12.5058844 6.81325814,12.6711252 L8.99997854,14.8578456 L11.1866989,12.6711252 C11.3519398,12.5058844 11.6191129,12.5058844 11.7843538,12.6711252 L12.5788694,13.4656409 C12.7441102,13.6308817 12.7441102,13.8980548 12.5788694,14.0632957 Z",
    id: "\\uF057"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReject);
export default __webpack_public_path__ + "static/media/reject.ccf27f45.svg";
export { ForwardRef as ReactComponent };